import {Component, Input} from '@angular/core';

/**
 * Generated class for the MemberTagComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'member-tag',
  templateUrl: 'member-tag.html'
})
export class MemberTagComponent {


  @Input() tag_type = 0;

  tag_name = ['活跃','吐槽','广告','红包'];

  constructor() {
    console.log('Hello MemberTagComponent Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/member-tag/member-tag.ts